import { useComparedVariablesContext } from '../state/useComparedVariablesState'

// The selected variables, or the single one when the page is opened for one variable
export const usePreparedComparedVariables = () => {
  const { comparedVariables, comparedVariable } = useComparedVariablesContext()
  return comparedVariables.length ? comparedVariables : comparedVariable ? [comparedVariable] : []
}
